import React, { FunctionComponent } from 'react';
import { UserProvider } from './UserContext';
import { ProjectProvider } from '../pages/projects/context';
import { LayoutProvider } from './LayoutContext';
import { TopMenuProvider } from './TopMenuContext';
import { IndicatorsProvider } from './IndicatorsContext';
import { WorkProvider } from './WorkContext';

const Provider: FunctionComponent<{}> = ({ children }) => {
  return (
    <TopMenuProvider>
      <UserProvider>
        <ProjectProvider>
          <IndicatorsProvider>
            <WorkProvider>
              <LayoutProvider>{children}</LayoutProvider>
            </WorkProvider>
          </IndicatorsProvider>
        </ProjectProvider>
      </UserProvider>
    </TopMenuProvider>
  );
};

export default Provider;
